import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-image-bucket', (editor, opts) => {
  const config = {
    blocks: [
      'dynamicImage',
    ],
    name: 'dynamicImage',
    stylePrefix: 'gjs-',
    labelDynImg: 'Image DB',
    defText: 'Sample',
    category: 'Base de Datos',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
